import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { DEFAULT_THEME_COLOR } from '../../constants/theme';

const WEEKDAYS = ['Nd', 'Pn', 'Wt', 'Śr', 'Cz', 'Pt', 'So'];

const PredictionWeekStrip = ({ predictions, onSelectDay, selectedDate }) => {
  if (!predictions?.length) return null;

  return (
    <Box sx={{ display: 'flex', gap: 1, overflowX: 'auto', pb: 1 }}>
      {predictions.map(day => {
        const dt = new Date(day.date + 'T12:00:00');
        const weekday = WEEKDAYS[dt.getDay()];
        const top = day.species?.[0];
        const isSelected = day.date === selectedDate;

        return (
          <Paper
            key={day.date}
            onClick={() => onSelectDay(day)}
            elevation={isSelected ? 3 : 1}
            sx={{
              minWidth: 64,
              p: 1,
              cursor: 'pointer',
              textAlign: 'center',
              bgcolor: isSelected ? DEFAULT_THEME_COLOR : 'background.paper',
              color: isSelected ? 'white' : 'text.primary',
              borderRadius: 2,
              border: isSelected ? 'none' : '1px solid #e0e0e0',
              flexShrink: 0,
            }}
          >
            <Typography variant="caption" display="block" fontWeight="bold">{weekday}</Typography>
            <Typography variant="caption" display="block" sx={{ fontSize: 9 }}>{day.date.slice(5)}</Typography>
            {top && (
              <>
                <Box sx={{
                  width: 28,
                  height: 28,
                  borderRadius: '50%',
                  bgcolor: isSelected ? 'rgba(255,255,255,0.4)' : DEFAULT_THEME_COLOR,
                  opacity: 0.3 + top.probability * 0.7,
                  mx: 'auto',
                  my: 0.5,
                }} />
                <Typography variant="caption" display="block" sx={{ fontSize: 9, textTransform: 'capitalize', lineHeight: 1.2 }}>
                  {top.name}
                </Typography>
              </>
            )}
          </Paper>
        );
      })}
    </Box>
  );
};

export default PredictionWeekStrip;
